import React from 'react';

const Label = React.forwardRef(({ className = '', ...props }, ref) => {
  const baseClasses = "text-sm font-medium leading-none text-gray-700 dark:text-gray-200 peer-disabled:cursor-not-allowed peer-disabled:opacity-70";
  
  const classes = `${baseClasses} ${className}`.trim();

  return (
    <label
      ref={ref}
      className={classes}
      {...props}
    />
  );
});

Label.displayName = "Label";

export { Label }; 